import { render } from "./FormularioUsuario.vue?vue&type=template&id=4234346e"
import script from "./FormularioUsuario.vue?vue&type=script&lang=js"
export * from "./FormularioUsuario.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/vue/vue-crud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__